import { Modal, Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { fetchWithAuth } from "../api/fetchWithAuth";

function EraFeatureFormModal({ show, onClose, onSaved, feature }) {
  const isEdit = !!feature;

  const [form, setForm] = useState({
    ft_number: "",
    ft_title: ""
  });

  useEffect(() => {
    if (feature) {
      setForm({
        ft_number: feature.ft_number ?? "",
        ft_title: feature.ft_title ?? ""
      });
      return;
    }

    setForm({
      ft_number: "",
      ft_title: ""
    });
  }, [feature, show]);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async () => {
    const payload = {
      ft_number: form.ft_number.trim(),
      ft_title: form.ft_title.trim()
    };

    const url = isEdit
      ? `/api/era-features/${encodeURIComponent(feature.ft_number)}`
      : "/api/era-features";

    const method = isEdit ? "PUT" : "POST";

    const res = await fetchWithAuth(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    if (!res.ok) {
      const error = await res.json().catch(() => null);
      alert(error?.error || "Save failed");
      return;
    }

    onSaved();
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {isEdit ? "Edit ERA Feature" : "Add ERA Feature"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Number</Form.Label>
            <Form.Control
              name="ft_number"
              value={form.ft_number}
              onChange={handleChange}
              disabled={isEdit}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Title</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="ft_title"
              value={form.ft_title}
              onChange={handleChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>

        <Button variant="success" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EraFeatureFormModal;
